import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { requestPermission, messaging, onMessage } from "../../utils/firebase.config";
import {
  getPushNotificationData,
  navToNotificationDetails,
  registerDeviceToken,
} from "../../services/notification-service";
import useNotificationStore from "../../stores/useNotificationStore";
import useUserStore from "../../stores/store";
let bgMessageId = "";

function FcmInitComponentV2() {
  const navigate = useNavigate();
  const { setHasNewNotification } = useNotificationStore();
  const { restaurantId } = useUserStore();

  useEffect(() => {
    // At very first loading it will ensure that it is registed otherwise there may error
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/firebase-messaging-sw.js");
    }

    registerDeviceToken();
  }, []);

  useEffect(() => {
    requestPermission();

    // foreground messages
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("Message received in foreground:", payload);
      const { data } = payload;
      const { title, options } = getPushNotificationData(data);

      if (Notification.permission !== "granted") {
        // fallback: in-app UI (toast)
        return;
      }

      // Display notification if restaurant in notification and current operating restaurant match
      if (restaurantId !== data.restaurantId) {
        return;
      }

      console.log("------inside forground message----data.action", { "data.action": data.action, data });
      // Handle only stock reach minimum value cause others are handled throw socket
      if (data.action !== "stock") {
        console.log("----------------inside data.action checking-------------");
        return;
      }

      console.log('--------------after --data.action !== "stock"--');

      setHasNewNotification(true);
      // Browser notification
      const notificationInstance = new Notification(title, options);

      // Handle click on the notification
      notificationInstance.onclick = function (event) {
        event.preventDefault();

        notificationInstance.close();
        navToNotificationDetails(navigate, event.currentTarget.data);
      };
    });

    return () => {
      if (typeof unsubscribe === "function") unsubscribe();
    };
  }, []);

  // Listen for post messages from the service worker. Service worker and app communication
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", function (event) {
        // Currently it is receiving only minimum stock event from sw
        const { originalData, messageId } = event.data;

        // Ignoring forground message here where fcmMessageId exist and in that case messageId will be undefined
        if (!messageId) {
          return;
        }

        setHasNewNotification(true);

        // for same push multiple message received from sw
        if (bgMessageId !== messageId) {
          bgMessageId = messageId;
          navToNotificationDetails(navigate, originalData);
        }
      });
    }
  }, []);

  // Sending default restaurant to service working on user state change
  useEffect(() => {
    if (restaurantId) {
      navigator.serviceWorker.ready.then((reg) => {
        if (reg.active) {
          reg.active.postMessage({
            type: "INIT_DATA",
            restaurantId,
          });
        }
      });
    }
  }, [restaurantId]);

  return <></>;
}

export default FcmInitComponentV2;
